<template>
  <div>
    <div class="mt-2">
      <vx-card
        :title="'Status da Proposta: ' + propose.config.approved"
        :subtitle="propose.config.reprovedBy"
        add-class="font-semibold"
        subtitle-color="#EA5455"
      >
        <div>
          <div class="flex">
            <div>
              <p class="font-semibold">Criado por:</p>
            </div>
            <div>
              <p class="ml-1">{{ propose.createdBy.email }}</p>
            </div>
          </div>
        </div>

        <div class="grid grid-cols-4 mt-4">
          <!--1 -->
          <div>
            <p class="font-semibold">Data da Análise:</p>
          </div>
          <div>
            <p>{{ propose.createdAt | formatDate }}</p>
          </div>

          <!--7 -->
          <div>
            <p></p>
          </div>
          <div>
            <p></p>
          </div>

          <!--2 -->
          <div>
            <p class="font-semibold">Balanço:</p>
          </div>
          <div>
            <p v-if="propose.config && propose.config.balance">
              {{ propose.config.balance.date | formatDate }}
            </p>
          </div>

          <!--8 -->
          <div>
            <p class="font-semibold">Em recuperação judicial?</p>
          </div>
          <div>
            <p>{{ propose.config.judicialRehabilitation | formatBoolean }}</p>
          </div>

          <div>
            <p class="font-semibold">Penalidade:</p>
          </div>
          <div>
            <p v-if="propose.config.reprovedBy != null">
              {{
                propose.config.reprovedBy.replace(
                  "Motivo(s) da reprovação: ",
                  ""
                )
              }}
            </p>
          </div>

          <!--3 -->
          <div>
            <p class="font-semibold">Score:</p>
          </div>
          <div>
            <p>
              {{
                propose.config.scoreCardLabel
                  ? propose.config.scoreCardLabel.label
                  : ""
              }}
            </p>
          </div>

          <!--9 -->
          <div>
            <p class="font-semibold">Pendências Fiscais ou Trabalhistas:</p>
          </div>
          <div>
            <p>{{ propose.config.laborClaim | formatBoolean }}</p>
          </div>

          <!--4 -->
          <div>
            <p class="font-semibold">Pendências Comerciais ou Financeiras:</p>
          </div>
          <div>
            <p>{{ propose.config.financialDisputes | formatBoolean }}</p>
          </div>

          <!--10 -->

          <!--5 -->
          <div>
            <p class="font-semibold">Serasa</p>
          </div>
          <div>
            <p v-if="propose.config.serasa">
              {{ propose.config.serasa.value }}
            </p>
            <p v-else>Sem nota</p>
          </div>

          <!--11 -->
          <div>
            <p class="font-semibold">Ultrapassou limite</p>
          </div>
          <div>
            <p v-if="propose.config">
              {{ propose.config.exceededLimit | formatBoolean }}
            </p>
          </div>

          <!--6 -->
          <div>
            <p class="font-semibold">Compliance</p>
          </div>
          <div>
            <p>
              {{
                propose.config.compliance
                  ? propose.config.compliance.description
                  : "Sem nota"
              }}
            </p>
          </div>

          <!--12 -->
          <div>
            <p class="font-semibold">Nota:</p>
          </div>
          <div>
            <p>{{ propose.config.scoreValue | toDecimal }}</p>
          </div>
        </div>
      </vx-card>
    </div>

    <vs-row vs-type="flex">
      <vs-col
        vs-type="flex"
        vs-lg="6"
        vs-sm="12"
        class="my-2"
        style="padding-left: 0"
      >
        <vx-card title="Informações do Cliente e Garantidor" fixedHeight>
          <div slot="header"></div>
          <div class="grid grid-cols-4 gap-4">
            <div>
              <p class="font-semibold">Garantidor</p>
            </div>
            <div v-if="propose.config.guarantor">
              {{ propose.config.guarantor.name }}
            </div>

            <div>
              <p class="font-semibold">Cliente</p>
            </div>
            <div v-if="propose.config.client">
              {{ propose.config.client.name }}
            </div>

            <div>
              <p class="font-semibold">CNPJ do Garantidor</p>
            </div>
            <div
              v-if="
                propose.config.guarantor != null &&
                (propose.config.guarantor.cnpjAlfa != null || propose.config.guarantor.cnpj != null)
              "
            >
              {{ (propose.config.guarantor.cnpjAlfa || propose.config.guarantor.cnpj) | formatCnpj }}
            </div>

            <div>
              <p class="font-semibold">CNPJ do Cliente</p>
            </div>
            <div
              v-if="
                propose.config.client != null &&
                (propose.config.client.cnpjAlfa != null || propose.config.client.cnpj != null)
              "
            >
              {{ (propose.config.client.cnpjAlfa || propose.config.client.cnpj) | formatCnpj }}
            </div>

            <div>
              <p class="font-semibold">Endereço</p>
            </div>
            <div v-if="propose.config.client != null">
              {{ propose.config.client.descrLogradouro }}
              {{ propose.config.client.logradouro }},
              {{ propose.config.client.numero }}
            </div>

            <div>
              <p class="font-semibold">Endereço</p>
            </div>
            <div v-if="propose.config.guarantor != null">
              {{ propose.config.guarantor.descrLogradouro }}
              {{ propose.config.guarantor.logradouro }},
              {{ propose.config.guarantor.numero }}
            </div>

            <div>
              <p class="font-semibold">Estado - Município</p>
            </div>
            <div>
              <span v-if="propose.config.client != null">
                {{ propose.config.client.uf }} -
                {{ propose.config.client.city }}
              </span>
            </div>

            <div>
              <p class="font-semibold">Estado - Município</p>
            </div>
            <div>
              <span v-if="propose.config.guarantor != null && propose.config.guarantor.city != null">
                {{ propose.config.guarantor.uf }} -
                {{ propose.config.guarantor.city }}
              </span>
            </div>

            <div>
              <p class="font-semibold">Tipo</p>
            </div>

            <div>
              <span v-if="propose.config.client != null && propose.config.client.companyType != null">
                {{ propose.config.client.companyType }}
              </span>
            </div>

            <div>
              <p class="font-semibold">Tipo</p>
            </div>

            <div>
              <span v-if="propose.config.guarantor != null && propose.config.guarantor.companyType != null">
                {{ propose.config.guarantor.companyType }}
              </span>
            </div>

            <div>
              <p class="font-semibold">Volume financeiro total</p>
            </div>

            <div>
              <span v-if="propose.config.totalAmount != null">
                R$ {{ propose.config.totalAmount | toDecimal }}
              </span>
            </div>
          </div>
        </vx-card>
      </vs-col>

      <vs-col
        vs-type="flex"
        vs-lg="6"
        vs-sm="12"
        class="my-2"
        style="padding: 0"
      >
        <vx-card
          fixedHeight
          :title="propose.config.operationType | formatOperationTypeTitle"
        >
          <vs-table stripe :data="groupValues">
            <template slot="header"> </template>
            <template slot="thead">
              <th>Período</th>
              <th>Operação</th>
              <th>Volume Médio</th>
              <th>Preço Médio</th>
              <th>Submercado</th>
              <th>Tipo</th>
              <th>Volume financeiro (R$)</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <td>{{ row.period }}</td>
                <td>{{ row.operation }}</td>
                <td>{{ row.volume | toDecimal }}</td>
                <td>{{ row.averagePrice | toDecimal }}</td>
                <td>{{ row.market }}</td>
                <td>{{ row.energyType }}</td>
                <td>R$ {{ row.amount | toDecimal }}</td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </vs-col>
    </vs-row>

    <vx-card title="Comentários">
      <vs-row vs-type="flex" class="mb-4">
        <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
          <vs-list>
            <vs-list-header></vs-list-header>
            <vs-list-item
              icon="person"
              v-for="(row, indextr) in propose.slaMessage"
              :key="indextr"
              :title="row.title"
              :subtitle="row.subtitle"
            />
          </vs-list>
        </vs-col>
      </vs-row>
    </vx-card>

    <vx-card title="Garantia" class="mt-2" fixed-height>
      <vs-row vs-type="flex" vs-justify="start">
        <vs-col vs-type="flex" vs-lg="6" vs-sm="12" class="mb-2">
          <div class="grid grid-cols-2 gap-4">
            <div class="font-semibold">
              <p>Proposta de Garantia:</p>
            </div>
            <div>
              <p>{{ propose.config.guaranteeType | formatGuarantee }}</p>
            </div>

            <div class="font-semibold">
              <p>Equivalente em Meses:</p>
            </div>
            <div>
              <p v-if="propose.config.guaranteePeriod">
                {{ propose.config.guaranteePeriod }}
              </p>
              <p v-else>-</p>
            </div>

            <div class="font-semibold">
              <p>Prazo de Pagamento em Dias:</p>
            </div>
            <div>
              <p v-if="propose.config.paymentTerm">
                {{ propose.config.paymentTerm }}
              </p>
              <p v-else>-</p>
            </div>
          </div>
        </vs-col>

        <vs-col
          v-if="propose.config.operationType === 'LONG'"
          vs-type="flex"
          vs-lg="6"
          vs-sm="12"
          class="mb-2"
        >
          <div class="grid grid-cols-2 gap-4">
            <span
              >No caso de compra por parte da ENERGISA não é necessário busca a
              garantia pelo rating da ENERGISA. A mesa deve tentar sugerir a
              garantia com menor custo.</span
            >
          </div>
        </vs-col>

        <vs-col
          v-if="propose.config.operationType !== 'LONG'"
          vs-type="flex"
          vs-lg="6"
          vs-sm="12"
          class="mb-2"
        >
          <div class="grid grid-cols-2 gap-4">
            <div class="font-semibold">
              <p>Garantia Recomendada Pela Política de Crédito</p>
            </div>
            <div>
              <p>{{ propose.config.recommendedGuarantee }}</p>
            </div>

            <div class="font-semibold">
              <p>Equivalente em Meses</p>
            </div>
            <div>
              <p>{{ propose.config.recommendedPeriod }}</p>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <div>
      <vx-card
        class="mt-4"
        title="Limites de Exposição | Período da Proposta"
        fixed-height
        v-if="propose.proposeType === 'ENERGY'"
      >
        <div class="grid grid-cols-4">
          <div class="font-semibold">
            Limite de Exposição Mensal por Volume:
          </div>
          <div>
            <p v-if="this.values != null && this.values.length > 0">
              {{ values[0].data[0] | toDecimal }}
            </p>
          </div>
        </div>

        <div class="mt-6 chart">
          <GenericChart
            id="limit-chart"
            style="width: 1000px"
            :values="values"
          />
        </div>

        <p class="font-semibold">Regras</p>
        <p>
          4.1.GERADOR: Limite de Exposição Mensal por Volume: 25% da Garantia
          Física do GRUPO GERADOR. Se não houver garantia física divulgada, o
          limite será 25% da média de geração dos últimos 48 meses.
        </p>
        <p>
          4.2.COMERCIALIZADOR: Limite de Exposição Mensal por Volume: 15% da
          média do volume transacionado (compra) pela Contraparte na CCEE nos
          últimos 12 meses.
        </p>
        <p>
          4.3.CONSUMIDOR FINAL: Limite de Exposição Mensal por Volume: 10% do
          faturamento mensal da contraparte
        </p>
      </vx-card>
    </div>

    <vx-card
      title="Limites de Exposição | Período Completo (Período de todas as operações do book)"
      class="mt-4"
      v-if="propose.proposeType === 'ENERGY'"
    >
      <div class="mt-6 chart">
        <GenericChart
          id="limit-chart-complete"
          style="width: 1000px"
          :values="valuesComplete"
        />
      </div>
    </vx-card>

    <vx-card class="mt-4" title="Fluxo de Caixa">
      <div class="mt-6 chart">
        <CurrencyChart
          id="total-amount-chart"
          style="width: 1000px"
          :values="amountValues"
        />
      </div>
    </vx-card>

    <vx-card
      class="mt-4"
      title="Informações da Proposta"
      v-if="propose.proposeType === 'ENERGY'"
    >
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <vs-table
            class="mt-6"
            stripe
            :data="propose.files"
            noDataText="Não há arquivos anexados nesta proposta"
          >
            <template slot="header">
              <h3>Arquivos anexados</h3>
            </template>

            <template slot="thead">
              <th>Arquivos</th>
              <th>Criado Por</th>
              <th>Data</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(row, indextr) in data" :key="indextr">
                <vs-td>
                  <a
                    style="cursor: pointer"
                    @click="downloadFile(row.fileName)"
                    >{{ row.fileName }}</a
                  >
                </vs-td>
                <vs-td>{{ row.createdBy.email }}</vs-td>
                <vs-td>{{ row.createdAt | formatDateTime }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </vx-card>

    <vx-card class="mt-4" title="Detalhes da Análise de Crédito" fixed-height>
      <h1 v-if="lastConfig && lastConfig.scoreCardLabel">
        Resultado da Análise: {{ lastConfig.scoreCardLabel.label }}
      </h1>

      <vs-row vs-type="flex" vs-justify="center" class="mt-8">
        <balanco-form
          ref="balancoForm"
          :balanceDtoTable="propose.config.balanceDtoTable"
        />
      </vs-row>

      <vs-row style="overflow: auto">
        <vs-col vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
          <vs-table
            class="mt-6"
            stripe
            :data="scoreTable"
            noDataText="Nenhum registro encontrado."
          >
            <template slot="thead">
              <th></th>
              <th>AAA</th>
              <th>AA</th>
              <th>A</th>
              <th>BBB</th>
              <th>BB</th>
              <th>B</th>
              <th>CCC</th>
              <th>CC</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(row, indextr) in data">
                <td>
                  <p class="font-semibold">{{ row.type }}</p>
                </td>
                <td>
                  <i
                    v-if="row.value === 'AAA'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'AA'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'A'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'BBB'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'BB'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'B'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'CCC'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
                <td>
                  <i
                    v-if="row.value === 'CC'"
                    class="far fa-check-circle fa-lg fa"
                  />
                </td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
    </vx-card>

    <div class="vx-row mt-4">
      <div class="vx-col">
        <vs-button @click="back">Voltar</vs-button>
        <span v-if="isCurrentUserAssigned && propose.lastSla.status !== 'DONE'">
          <vs-button
            class="bg-danger-gradient ml-2"
            @click="rejectPrompt = !rejectPrompt"
            >Recusar Proposta</vs-button
          >
          <vs-button
            class="bg-warning-gradient ml-2"
            @click="returnPrompt = !returnPrompt"
            >Retornar para Fase Anterior</vs-button
          >
          <vs-button
            v-if="propose.config.approved === 'Aprovada'"
            class="bg-success-gradient ml-2"
            @click="acceptPrompt = !acceptPrompt"
            >Aprovar Proposta</vs-button
          >
          <vs-button
            v-else
            class="bg-success-gradient ml-2"
            @click="acceptExceptionPrompt = !acceptExceptionPrompt"
            >Aprovar Proposta por Exceção</vs-button
          >
        </span>
        <vs-button class="bg-success ml-2" @click="downloadExcel"
          >Exportar em Excel</vs-button
        >
      </div>
    </div>

    <vs-prompt
      @accept="returnPropose()"
      title="Retornar"
      accept-text="Retornar"
      cancel-text="Cancelar"
      :is-valid="!counterDanger"
      :active.sync="returnPrompt"
    >
      <div>
        <span>Deseja retornar esta proposta para a estapa anterior?</span>
        <vs-textarea
          class="mt-2"
          label="Motivo"
          counter="1000"
          :counter-danger.sync="counterDanger"
          v-model="slaAction.comments"
        />
      </div>
    </vs-prompt>

    <vs-prompt
      @accept="acceptExceptionPropose()"
      title="Aprovar por exceção"
      accept-text="Aprovar"
      cancel-text="Cancelar"
      :active.sync="acceptExceptionPrompt"
    >
      <div>
        <span>Deseja aprovar por exceção esta proposta?</span>
        <vs-textarea
          class="mt-2"
          label="Motivo"
          counter="1000"
          :counter-danger.sync="counterDanger"
          v-model="slaAction.comments"
        />
      </div>
    </vs-prompt>

    <vs-prompt
      @accept="acceptPropose()"
      title="Aprovar"
      accept-text="Aprovar"
      cancel-text="Cancelar"
      :active.sync="acceptPrompt"
    >
      <div>
        <span>Deseja aprovar esta proposta?</span>
      </div>
    </vs-prompt>

    <vs-prompt
      @accept="rejectPropose()"
      title="Rejeitar"
      accept-text="Rejeitar"
      cancel-text="Cancelar"
      :active.sync="rejectPrompt"
    >
      <div>
        <span>Deseja rejeitar esta proposta?</span>
        <vs-textarea
          class="mt-2"
          label="Motivo"
          counter="1000"
          :counter-danger.sync="counterDanger"
          v-model="slaAction.comments"
        />
      </div>
    </vs-prompt>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import LimitBarChart from "../stats/LimitBarChart";
import BalancoForm from "../BalancoForm";
import CurrencyChart from "@/components/stats/CurrencyChart";
import GenericChart from "@/components/stats/GenericChart";

export default {
  name: "PropostaReport",
  components: {
    CurrencyChart,
    GenericChart,
    LimitBarChart,
    BalancoForm,
  },
  props: {
    proposeDb: Object,
  },
  watch: {
    proposeDb(newVal, oldVal) {
      Object.assign(this.propose, newVal);
      this.loadReport();
      this.getConcessionArea();
    },
  },
  data() {
    return {
      files: [],
      returnPrompt: false,
      acceptPrompt: false,
      acceptExceptionPrompt: false,
      rejectPrompt: false,
      reachedLimit: null,
      areaConcessao: false,
      values: [
        {
          label: "",
          labels: [],
          datasets: [],
          data: [],
        },
      ],
      valuesComplete: [
        {
          label: "",
          labels: [],
          datasets: [],
          data: [],
        },
      ],
      lastBalance: { guid: null },
      lastConfig: {
        scoreCardLabel: { label: null },
        balance: { guid: null },
      },
      propose: {
        proposeType: "ENERGY",
        files: [],
        createdAt: null,
        createdBy: {
          email: null,
        },
        operationType: null,
        comments: null,
        status: null,
        proposeValue: null,
        guid: null,
        config: {
          approved: false,
          reprovedBy: "",
          values: [],
          client: {
            cnpj: null,
            name: null,
            guid: null,
          },
          clientGuid: null,
          guarantor: {
            cnpj: null,
            name: null,
            guid: null,
          },
          guarantorGuid: null,
          guaranteeType: null,
          guaranteePeriod: null,
          serasa: null,
          sectorAnalysis: null,
          compliance: null,
          financialDisputes: null,
          judicialRehabilitation: null,
          penalty: null,
          laborClaim: null,
          balance: null,
          scoreTable: [],
          subfactorScores: [],
          computeWithoutBalance: false,
        },
        approved: null,
        approvedDescription: null,
        proposeCommitteeAssignList: null,
        proposeSla: [],
        lastSla: {
          description: null,
        },
        codigo: null,
        recommendedGuarantee: null,
        recommendedPeriod: null,
        userAssigned: null,
        createdByStr: null,
        flowAction: null,
        slaMessage: [],
      },
      scoreTable: [],
      groupValues: [],
      amountValues: [
        {
          label: "",
          labels: [],
          datasets: [],
          data: [],
        },
      ],
      counterDanger: false,
      slaAction: {
        action: null,
        comments: null,
      },
    };
  },
  computed: {
    isCurrentUserAssigned() {
      if (this.proposeDb.lastSla && this.proposeDb.lastSla.userAssigned) {
        const user = JSON.parse(localStorage.currentUser);
        if (this.proposeDb.lastSla.userAssigned.email === user.email)
          return true;
      }
      return false;
    },

    filename() {
      if (this.propose) {
        return this.propose.codigo + " - " + this.propose.config.client.name;
      }
      return "";
    },
  },
  methods: {
    back() {
      this.$router.push({ path: "/propose" });
    },

    loadReport() {
      this.getFiles();
      this.groupedValues();
      this.energyBalanceChart();
      this.loadScoreTable();
      this.loadAmountTable();
    },

    getFiles() {
      this.files = this.propose.files;
    },

    loadScoreTable() {
      const scores = this.propose.config.subfactorScores;
      this.lastConfig = this.propose.config;
      this.scoreTable = [];

      if (scores != null) {
        for (let i = 0; i < scores.length; i++) {
          if (scores[i].label == null) continue;
          const score = {
            type: scores[i].subfactor.name,
            value: scores[i].label.label.trim(),
          };
          this.scoreTable.push(score);
        }
      }
    },

    loadAmountTable() {
      this.amountValues = this.propose.config.amountValues;
    },

    groupedValues() {
      this.groupValues = this.propose.groupedValues;
    },

    energyBalanceChart() {
      this.valuesComplete = this.propose.config.energyChartComplete;
      this.values = this.propose.config.energyChart;
    },

    returnPropose() {
      this.updatePropose("RETURN");
    },

    rejectPropose() {
      this.updatePropose("DENIED");
    },

    acceptPropose() {
      this.updatePropose("APPROVE");
    },

    acceptExceptionPropose() {
      this.updatePropose("EXCEPTION");
    },

    updatePropose(slaAction) {
      this.slaAction.action = slaAction;
      axios
        .put(
          `${process.env.VUE_APP_API}/api/v1/propose/${this.propose.guid}/step`,
          this.slaAction
        )
        .then(() => {
          if (this.propose.lastSla.status === "REVIEW") {
            this.$router.go();
          } else {
            this.$router.push({ path: "/propose" });
          }
        });
    },

    getConcessionArea() {
      this.areaConcessao = this.propose.areaConcessao;
    },

    downloadExcel() {
      axios
        .get(
          `${process.env.VUE_APP_API}/api/v1/propose-report/excel/${this.propose.guid}`,
          {
            responseType: "blob",
          }
        )
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        });
    },

    downloadFile(row) {
      axios
        .get(`${process.env.VUE_APP_API}/api/v1/file/download`, {
          params: {
            proposeGuid: this.propose.guid,
            fileName: row,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          const filename = response.headers["x-suggested-filename"];
          link.setAttribute("download", filename);
          document.body.appendChild(link);
          link.click();
        });
    },
  },
};
</script>

<style scoped>
.fa {
  color: #28c76f;
}
.chart {
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: scroll;
}
</style>
